module.exports = __webpack_public_path__ + "img/badge.c5728020.svg";